<template>
  <div></div>
</template>

<script>
import config from "@/config";
export default {
  name: "PageNotFound",
  created: function() {
    window.location.href = `${config.ROUTE_PREFIX}/`;
  }
}
</script>
